<script lang="ts">
	//Formatting
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		ControlsContainer,
		FlexibleCard,
		Icon,
		LinearGauge,
		PlainTable,
		StatusIndicator,
		SystemStyles,
		Text,
	} from '@Shelly/shelly-design-system/index';
	//Helpers
	import {
		buildEvTemplate,
		getStatusIndicatorState,
	} from 'src/helpers/virtual_helpers/template_helpers/virtual_ev_template_helpers';
	//Components
	import TemplateToggle from 'src/components/DevicesSettings/VirtualComponents/Templates/components/TemplateToggle.svelte';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device;
	export let statuses: VCInterfaceStatus[];

	$: evData = buildEvTemplate(statuses);
</script>

<div class="flex-full-height">
	{#if evData.work_state}
		<div class="d-flex justify-content-center mb-m mt-s">
			<StatusIndicator
				title={evData.work_state.value}
				state={getStatusIndicatorState(evData.work_state.event)}
				subtitle={$format('label_current_state', { default: 'Current state' })}
			/>
		</div>
	{/if}
	<div class="flex-full-height justify-content-end">
		{#if evData.current}
			<FlexibleCard
				class="mb-s "
				backgroundColor="--color-0"
				padding="m"
				mainContentPrioritySlot="both"
				header={$format('em_current', { default: 'current' })}
				icon="fas fa-bolt"
			>
				<LinearGauge
					class="mt-s"
					type="incremented"
					incrementedValue={{
						value: evData.current?.rawValue ?? 0,
						color: SystemStyles.COLOR_ELECTRIC_VEHICLE,
						labelProps: {
							icon: 'fas fa-car',
							value: evData.current?.value || '',
							iconColor: SystemStyles.COLOR_ELECTRIC_VEHICLE,
						},
					}}
					unit={evData.max_charge?.unit || 'A'}
					minValue={0}
					maxValue={evData.max_charge?.rawValue ?? 40}
				/>
			</FlexibleCard>
		{/if}
		<FlexibleCard
			class="mb-s"
			backgroundColor="--color-0"
			padding="m"
			mainContentPrioritySlot="both"
			header={$format('power', { default: 'power' })}
			icon="fas fa-transformer-bolt"
		>
			<PlainTable class="width-full">
				<colgroup>
					<col class="col-label" />
					<col class="col-value" />
				</colgroup>
				<tbody>
					{#each evData.statusInfo as statusInfo}
						<tr class:no-vertical-padding={statusInfo.role === 'auto_balancing'}>
							<th
								><Icon
									class="mr-s"
									icon={statusInfo.icon}
									size="xs"
								/>{statusInfo.title}</th
							>
							{#if statusInfo.role === 'auto_balancing'}
								<td
									style="margin-right:-8px"
									class="d-flex align-items-center justify-content-end"
								>
									<TemplateToggle {device} status={statusInfo.status} />
								</td>
							{:else}
								<td>{statusInfo.value}</td>
							{/if}
						</tr>
					{/each}
				</tbody>
			</PlainTable>
		</FlexibleCard>
		{#if evData.auto_start}
			<ControlsContainer color="color-0">
				<svelte:fragment slot="first">
					<VirtualBooleanButton
						{device}
						componentID={evData.auto_start.id}
						value={evData.auto_start.event}
						useV2Components
						isWide
					/>
					<Text styleType="controls-large" class="mt-s text-bold"
						>{$format('vc_template_auto_start', { default: 'Auto start' })}</Text
					></svelte:fragment
				>
			</ControlsContainer>
		{/if}
	</div>
</div>

<style>
	.col-label {
		width: 70%;
	}
	.col-value {
		width: 30%;
	}
	tr.no-vertical-padding th,
	tr.no-vertical-padding td {
		padding-top: 0;
		padding-bottom: 0;
	}
</style>
